import React, { useMemo } from 'react';
import { ABORTED, ABORTED_STATUS, COMPLETED, COMPLETED_STATUS, DRAFT, DRAFT_STATUS, IN_PROGRESS, IN_PROGRESS_STATUS, INITIATED, INITIATED_STATUS, SCHEDULED, SCHEDULED_STATUS } from '../utils/Constants';
import { ABTestStatus } from '../types/ab';

type TCustomChip = {
    status: ABTestStatus | string | boolean | JSX.Element
}

const CustomChip = ({ status }: TCustomChip) => {

    const { bgColor, textColor, displayText, borderColor, rounded } = useMemo(() => {
        let bgColor: string;
        let textColor: string;
        let displayText: string | JSX.Element;
        let borderColor: string = '';
        let rounded: boolean = false

        if (typeof status === 'boolean') {
            bgColor = status ? '#fff' : '#E5E5EA';
            textColor = status ? 'text-white' : '#172B4D';
            borderColor = '#E5E5EA'
            displayText = status ? 'Reached' : 'Not Reached';
        } else {
            switch (status) {
                case DRAFT_STATUS:
                    bgColor = '#fff';
                    textColor = '#172B4D';
                    displayText = DRAFT;
                    borderColor = '#E5E5EA'
                    break;
                case INITIATED_STATUS:
                    bgColor = '#fff';
                    textColor = '#172B4D';
                    displayText = INITIATED;
                    borderColor = '#E5E5EA'
                    break;
                case SCHEDULED_STATUS:
                    bgColor = '#fff';
                    textColor = '#172B4D';
                    displayText = SCHEDULED;
                    borderColor = '#E5E5EA'
                    break;
                case ABORTED_STATUS:
                    bgColor = '#fce3e3';
                    textColor = '#7d2727';
                    displayText = ABORTED;
                    borderColor = '#E5E5EA'
                    break;
                case IN_PROGRESS_STATUS:
                    bgColor = '#FFF8DB';
                    textColor = '#DE7900';
                    displayText = IN_PROGRESS;
                    break;
                case COMPLETED_STATUS:
                    bgColor = '#E3FCEF';
                    textColor = '#006644';
                    displayText = COMPLETED;
                    break;
                default:
                    bgColor = '#dadbdd';
                    textColor = 'text-black';
                    displayText = status;
                    rounded = true
                    break;
            }
        }

        return { bgColor, textColor, displayText, borderColor, rounded };
    }, [status]);

    return (
        <div
            className={`tw-px-3.5 tw-py-1 ${rounded ? "tw-rounded-xl" : "tw-rounded"} tw-justify-center tw-items-center tw-gap-2.5 tw-inline-flex`}
            style={{
                backgroundColor: bgColor,
                color: textColor,
                borderColor: borderColor,
                borderWidth: borderColor ? '1px' : '0px',
                borderStyle: borderColor ? 'solid' : 'none'
            }}
        >
            <div className="tw-text-center tw-text-xs tw-font-medium">
                {displayText}
            </div>
        </div>
    );
}

export default CustomChip;